import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appCopyToClipboard]',
  standalone: true
})
export class CopyToClipboardDirective {

  @Input('appCopyToClipboard') textToCopy: string | number | undefined | null = '';

  constructor() {
  }

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (!this.textToCopy) {
      console.warn('No text provided to copy.');
    } else {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(`${this.textToCopy}`)
          .catch(err => {
            console.error('Failed to copy text using Clipboard API:', err);
          });
      }
    }
  }
}
